export const DATA = [
    {
        title: {
            tr: 'Anasayfa',
            en: 'Home',
            de: 'Startseite'
        },
        link: '/'
    },
    {
        title: {
            tr: 'Kurumsal',
            en: 'Corporate',
            de: 'Unternehmen'
        },
        link: '/kurumsal',
        dropDown: [
            {
                title: {
                    tr: 'Hakkımızda',
                    en: 'About Us',
                    de: 'Über Uns'
                },
                link: '/kurumsal'
            },
            {
                title: {
                    tr: 'Vizyon',
                    en: 'Vision',
                    de: 'Vision'
                },
                link: '/kurumsal'
            },
            {
                title: {
                    tr: 'Misyon',
                    en: 'Mission',
                    de: 'Mission'
                },
                link: '/kurumsal'
            }
        ]
    },
    {
        title: {
            tr: 'Hizmetlerimiz',
            en: 'Our Services',
            de: 'Unsere Dienstleistungen'
        },
        link: '/hizmetler/hava-yolu-tasimaciligi',
        dropDown: [
            {
                title: {
                    tr: 'Hava Yolu Taşımacılığı',
                    en: 'Air Freight',
                    de: 'Luftfracht'
                },
                link: '/hizmetler/hava-yolu-tasimaciligi'
            },
            {
                title: {
                    tr: 'Kara Yolu Taşımacılığı',
                    en: 'Road Transport',
                    de: 'Straßentransport'
                },
                link: '/hizmetler/kara-yolu-tasimaciligi'
            },
            {
                title: {
                    tr: 'Deniz Yolu Taşımacılığı',
                    en: 'Sea Freight',
                    de: 'Seefracht'
                },
                link: '/hizmetler/deniz-yolu-tasimaciligi'
            },
            {
                title: {
                    tr: "İntermodal Taşımacılık",
                    en: "Intermodal Transportation",
                    de: "Intermodaler Transportdienst"
                },
                link: "/hizmetler/intermodal-tasimacilik-hizmeti"
            },
            {
                title: {
                    tr: 'Gümrükleme Hizmetleri',
                    en: 'Customs Services',
                    de: 'Zolldienstleistungen'
                },
                link: '/hizmetler/gumrukleme-hizmetleri'
            },

        ]
    },
    {
        title: {
            tr: 'Neden Genesis?',
            en: 'Why Genesis?',
            de: 'Warum Genesis?'
        },
        link: '/neden-genesis-trade-lojistik'
    },
    {
        title: {
            tr: 'Referanslar',
            en: 'References',
            de: 'Referenzen'
        },
        link: '/guncelleniyor',
        dropDown: [
            {
                title: {
                    tr: 'Müşteri Yorumları',
                    en: 'Customer Reviews',
                    de: 'Kundenbewertungen'
                },
                link: '/guncelleniyor'
            },
            {
                title: {
                    tr: 'Başarı Hikayeleri',
                    en: 'Success Stories',
                    de: 'Erfolgsgeschichten'
                },
                link: '/guncelleniyor'
            }
        ]
    },
    {
        title: {
            tr: 'İletişim',
            en: 'Contact',
            de: 'Kontakt'
        },
        link: '/iletisim'
    }
];
